import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { SvgIconComponent } from '@ngneat/svg-icon';
import { TranslateModule } from '@ngx-translate/core';
import { AppointmentStatusColorV2, Provider } from '@ffd/api-client';
import { PmsDisplayCodePipe } from '@libs/utils';
import { TooltipModule } from '@libs/ui-lib';

import { ScheduleLegendDialogData } from './schedule-legend-dialog.interface';

@Component({
  selector: 'lib-schedule-legend-dialog',
  standalone: true,
  imports: [CommonModule, SvgIconComponent, TranslateModule, TooltipModule, PmsDisplayCodePipe],
  templateUrl: './schedule-legend-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ScheduleLegendDialogComponent {
  public readonly dialogData: ScheduleLegendDialogData = inject(DIALOG_DATA);
  private readonly dialogRef = inject(DialogRef);

  protected get appointmentStatusColors(): AppointmentStatusColorV2[] {
    return this.dialogData.appointmentStatusColors || [];
  }

  protected get providers(): Provider[] {
    return this.dialogData.providers || [];
  }

  public onCloseDialog(): void {
    this.dialogRef.close();
  }

  public onBackgroundClick(): void {
    this.onCloseDialog();
  }

  protected getStatusCode(status: AppointmentStatusColorV2): string {
    if (status.statusCode) {
      return status.statusCode;
    }
    const FALLBACK_LENGTH = 4;
    return (status.statusName ?? '').replaceAll(/\s+/g, '').slice(0, FALLBACK_LENGTH).toUpperCase();
  }

  protected convertToHexColor(color: AppointmentStatusColorV2): string {
    const HEX_BASE = 16;
    const HEX_PADDING = 2;
    const r = Math.round(color.red);
    const g = Math.round(color.green);
    const b = Math.round(color.blue);
    return `#${r.toString(HEX_BASE).padStart(HEX_PADDING, '0')}${g.toString(HEX_BASE).padStart(HEX_PADDING, '0')}${b
      .toString(HEX_BASE)
      .padStart(HEX_PADDING, '0')}`;
  }

  protected formatProviderColor(color: string): string {
    return color.startsWith('#') ? color : `#${color}`;
  }
}
